import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';
import { Colors } from '../../../../../assets/styles';

const useStyles = makeStyles((theme: Theme) => ({
  titleWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 20,
  },
  titleUnchecked: {
    color: Colors.Gray,
  },
  toggleLabel: {
    fontSize: 13,
    color: Colors.Yellow,
  },
}));

export default useStyles;